import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import { AppLayout } from '@/pages/_layout/app-layout'
import { useRedirections } from '@/shared/hooks/useRedirections'

import { LayoutSkeleton } from '../lazy'

const Avail = lazy(async () => await import('../../pages/avail'))
const Agency = lazy(async () => await import('../../pages/agency'))
const BookingBook = lazy(async () => await import('../../pages/booking'))
const BookingAdd = lazy(
  async () => await import('../../pages/booking/booking-add'),
)
const WaitingApproval = lazy(
  async () => await import('../../pages/waiting-approval'),
)
const UploadedFiles = lazy(
  async () => await import('../../pages/batch-reservations/files/files'),
)
const PoliciesPage = lazy(
  async () => await import('../../pages/agency/policies'),
)

const PolicyDetails = lazy(
  async () => await import('../../pages/agency/policies/details'),
)

const RegisterChainAgency = lazy(
  async () =>
    await import('../../pages/register-chain-agency/RegisterChainAgency'),
)

const BatchReservationsRequests = lazy(
  async () => await import('../../pages/batch-reservations/requests/requests'),
)
const CreateAgency = lazy(async () => await import('../../pages/agency/create'))
const HotelDetail = lazy(async () => await import('../../pages/hotel/detail'))

const BookinDetail = lazy(
  async () => await import('../../pages/booking/booking-detail'),
)

const Request = lazy(async () => await import('../../pages/request/requests'))

const AgencyDetails = lazy(
  async () => await import('../../pages/agency/details'),
)

const BookingEdit = lazy(
  async () => await import('../../pages/booking/booking-edit'),
)

const AgencyConfig = lazy(async () => await import('../../pages/agency/config'))
const Customers = lazy(async () => await import('../../pages/agency/customer'))
const CustomersDetails = lazy(
  async () => await import('../../pages/agency/customer/details'),
)

export function RoutesApp(): JSX.Element {
  useRedirections()

  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <div className="mt-0">
        <Routes>
          <Route
            path="/register-chain-agency"
            element={<RegisterChainAgency />}
          />

          <Route path="/waiting-approval" element={<WaitingApproval />} />

          <Route path="/" element={<AppLayout />}>
            <Route path="" element={<Avail />} />
            <Route path="booking/payment" element={<BookingAdd />} />
            <Route path="booking/edit" element={<BookingEdit />} />
            {/* <Route path="/booking/edit" element={<BookingEditNew />} /> */}
            <Route path="booking/myReservations" element={<BookingBook />} />
            <Route path="hotel/detail" element={<HotelDetail />} />
            <Route path="booking/detail" element={<BookinDetail />} />
            <Route path="requesties" element={<Request />} />

            {/* Batch Reservations */}
            <Route
              path="batch-reservations/uploaded-files"
              element={<UploadedFiles />}
            />

            <Route
              path="batch-reservations/requests"
              element={<BatchReservationsRequests />}
            />

            {/* Agency Chain */}
            <Route path="/agency/customers" element={<Customers />} />
            <Route
              path="/agency/customers/:customerId"
              element={<CustomersDetails />}
            />
            <Route path="agency/create" element={<CreateAgency />} />
            <Route path="/agency" element={<Agency />} />
            <Route path="/agency/config" element={<AgencyConfig />} />
            <Route path="/agency/details" element={<AgencyDetails />} />
            <Route path="/agency/config" element={<AgencyConfig />} />

            {/* Agency */}
            <Route path="/agency/:agencyId" element={<Agency />} />
            <Route
              path="/agency/:agencyId/details"
              element={<AgencyDetails />}
            />
            <Route path="/agency/:agencyId/config" element={<AgencyConfig />} />
            <Route path="agency/policies" element={<PoliciesPage />} />
            <Route
              path="agency/policies/:policyId"
              element={<PolicyDetails />}
            />
            <Route path="/agency/:agencyId/create" element={<CreateAgency />} />
            <Route
              path="agency/:agencyId/policies"
              element={<PoliciesPage />}
            />

            <Route
              path="agency/:agencyId/policies/:policyId"
              element={<PolicyDetails />}
            />

            {/* Point of Sales */}
            <Route
              path="/agency/:agencyId/point-of-sales/:posId/details"
              element={<AgencyDetails />}
            />

            <Route
              path="/agency/:agencyId/point-of-sales/:posId/config"
              element={<AgencyConfig />}
            />

            <Route
              path="agency/:agencyId/point-of-sales/:posId/policies"
              element={<PoliciesPage />}
            />

            <Route
              path="agency/:agencyId/point-of-sales/:posId/policies/:policyId"
              element={<PolicyDetails />}
            />
          </Route>
        </Routes>
      </div>
    </Suspense>
  )
}
